import React from "react";

const FieldLabel: React.FC<{ label: string }> = ({ label }) => (
  <label className="text-sm text-[#1E1E1E] font-[500]">{label}</label>
);

const ReadOnlyInput: React.FC<{ value?: string; placeholder?: string }> = ({
  value,
  placeholder,
}) => (
  <input
    type="text"
    readOnly
    value={value || ""}
    placeholder={placeholder}
    className="h-[38px] px-3 border border-gray-200 rounded-[6px] text-sm text-[#1E1E1E] bg-[#FFFFFF] w-full"
  />
);

const ReadOnlyTextArea: React.FC<{ html?: string }> = ({ html }) => (
  <div
    className="min-h-[160px] p-3 border border-gray-200 rounded-[6px] text-sm text-[#1E1E1E] bg-[#FFFFFF] w-full whitespace-pre-wrap"
    dangerouslySetInnerHTML={{ __html: html || "" }}
  />
);

export type ViewEmailData = {
  clientName: string;
  projectName: string;
  scenario: string;
  sentDate?: string;
  sentTime?: string;
  to: string[];
  cc: string[];
  bcc: string[];
  subject: string;
  contentHtml: string; // HTML string
};

const ViewEmailForm: React.FC<{ data: ViewEmailData }> = ({ data }) => {
  const toStr = data.to?.join(", ") || "";
  const ccStr = data.cc?.join(", ") || "";
  const bccStr = data.bcc?.join(", ") || "";

  return (
    <div className="p-6 flex flex-col gap-5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex flex-col gap-1">
          <FieldLabel label="Client name" />
          <ReadOnlyInput value={data.clientName} />
        </div>
        <div className="flex flex-col gap-1">
          <FieldLabel label="Project" />
          <ReadOnlyInput value={data.projectName} />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex flex-col gap-1">
          <FieldLabel label="Scenario" />
          <ReadOnlyInput value={data.scenario} />
        </div>
        <div className="flex w-full gap-1">
        <div className="flex flex-col gap-1 mr-1 w-[50%]">
          <FieldLabel label="Sent date" />
          <ReadOnlyInput value={data.sentDate} />
        </div>
        <div className="flex flex-col gap-1 w-[50%]">
          <FieldLabel label="Sent time" />
          <ReadOnlyInput value={data.sentTime} />
        </div>
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <FieldLabel label="To" />
        <ReadOnlyInput value={toStr} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex flex-col gap-1">
          <FieldLabel label="Cc" />
          <ReadOnlyInput value={ccStr} />
        </div>
        <div className="flex flex-col gap-1">
          <FieldLabel label="Bcc" />
          <ReadOnlyInput value={bccStr} />
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <FieldLabel label="Subject" />
        <ReadOnlyInput value={data.subject} />
      </div>

      <div className="flex flex-col gap-1">
        <FieldLabel label="Email content" />
        <ReadOnlyTextArea html={data.contentHtml} />
      </div>
    </div>
  );
};

export default ViewEmailForm;
